
export const propertyHelperMixin = {

  methods: {
    getPropertyByPath (item, propertyPath, placeholder) {
      const properties = propertyPath.split('.')
      if (properties.length <= 0) {
        return placeholder
      }
      let result = item
      let resultPlaceholder = null
      for (let i = 0; i < properties.length; i++) {
        if (result[properties[i]]) {
          result = result[properties[i]]
        } else {
          resultPlaceholder = placeholder
          break
        }
      }
      if (resultPlaceholder !== null) {
        return resultPlaceholder
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/propertyHelperMixin.js